

export enum LANDING_SCALAR {
    CANVAS="canvas",
    ANIMATED_DELAY = "animated_delay",
    ANIMATED = "animated",
    COMPOSITION = "composition",
    PROPORTION = "proportion",
    DOT_NAVIGATION="dot_navigation",
    CARD="card",
    CARD_ORDER="card_order",
    MARRIAGE_ITEM="marriage_item",
    CONTENT="content",
    USER="user",
    TYPOGRAPHY="typography",
    FIELD_INPUT="field_input",
    FIELD_INPUT_ITEM="field_input_item",
    SCREEN_PLACE="screen_place",
    VK_VIDEO="vk_video",
    HEADER_ORDER="header_order",
    FLOATS="floats",
    CATEGORY="category",
    CATEGORY_ID="category_id",
    LANDING_MEMBER_ID="landing_member_id",
    MODAL="modal",
    RATING="PERating",
    EXTERNAL_LINK_FEED="external_link_feed",
}

export enum ANIMATED_DELAY_VALUE {
    VALUE_0 = 300,
    VALUE_1 = 500,
    VALUE_2 = 700,
    VALUE_3 = 900,
    VALUE_4 = 1100,
    VALUE_5 = 1300,
    VALUE_6 = 1500,
}